import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '@arianeeprivate/wallet-shared-components';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

import { Button } from '../../../components/redesign/button/models/button.model';
import { ArianeeService } from '../../../providers/arianee-service/arianee.service';
import { BackupService } from '../../../providers/backup-service/backup.service';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';

@Component({
	selector: 'app-backup-import-success',
	templateUrl: './backup-import-success.page.html',
	styleUrls: ['./backup-import-success.page.scss'],
})
export class BackupImportSuccess implements AfterViewInit, OnInit {
	@ViewChild('header', {
		read: ElementRef,
		static: false,
	})
	header: ElementRef<HTMLElement>;

	backupCloudBtn: Button;
	backToHomeBtn: Button;

	public headerHeight: number = 0;
	public cloudBackupLoading = false;
	public cloudBackupDisabled = false;

	constructor(
		private eventLogger: EventLoggerService,
		private arianeeService: ArianeeService,
		private platform: Platform,
		private router: Router,
		private backupService: BackupService,
		private toasterService: ToasterService,
		private translate: TranslateService,
	) {}

	ngOnInit() {
		this.backupCloudBtn = {
			title: {
				text: this.translate.instant('Import.backupViaCloudProviderBtn', {
					cloudProvider: this.cloudProvider,
				}),
			},
			buttonType: 'primary',
			loading: this.cloudBackupLoading,
			disabled: this.cloudBackupDisabled,
			icon: this.cloudBackupDisabled
				? {
						backgroundColor: 'transparent',
						fontSize: 20,
						stroke: 1,
						name: 'icon-check',
						width: '20px',
						height: '20px',
				  }
				: null,
		};

		this.backToHomeBtn = {
			title: {
				text: this.translate.instant('Import.backToHomeButton'),
			},
			buttonType: 'text',
		};
	}

	ngAfterViewInit() {
		this.log('screen', 'backup-import-success');
		this.setHeaderHeight();
	}

	private setHeaderHeight() {
		this.headerHeight = (
			this.header.nativeElement.firstElementChild as HTMLElement
		).offsetHeight;

		// Retry if css not yet loaded
		if (this.headerHeight === 0)
			setTimeout(this.ngAfterViewInit.bind(this), 10);
	}

	public get cloudProvider(): string {
		if (this.platform.is('ios')) {
			return 'iCloud';
		}

		return 'Google Drive';
	}

	private async log(type: 'screen' | 'event', name: string) {
		const address = await this.arianeeService.$address
			.pipe(take(1))
			.toPromise();

		if (type === 'screen') {
			this.eventLogger.logScreen(name, {
				publicKey: address,
			});
		} else {
			await this.eventLogger.logEvent(name, {
				publicKey: address,
			});
		}
	}

	public goToHome() {
		this.router.navigate(['/tab/brand-list']);
		this.log('event', 'backup-import-success__back-to-home');
	}

	public async cloudBackup() {
		if (this.cloudBackupDisabled) return;

		try {
			this.cloudBackupLoading = true;
			await this.backupService.backupMnemonic();
			await this.backupService.checkBackup();
			this.log('event', 'backup-import-success__cloud-backup-success');
			this.cloudBackupDisabled = true;
			this.toasterService.showRedesigned({
				title: 'Backup.backupSuccessfull',
				position: 'top',
				duration: 4000,
				color: 'success',
				icon: 'check',
			});
		} catch (e) {
			console.error('Error while performing cloud backup', e);
			this.toasterService.showRedesigned({
				title: 'Backup.failed',
				position: 'top',
				duration: 4000,
				color: 'danger',
				icon: 'cancel',
			});
			this.log('event', 'backup-import-success__cloud-backup-error');
		} finally {
			this.cloudBackupLoading = false;
		}
	}
}
